import { render, staticRenderFns } from "./crudOrdersReasonEvents.vue?vue&type=template&id=88cdd93e"
import script from "./crudOrdersReasonEvents.vue?vue&type=script&lang=js"
export * from "./crudOrdersReasonEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports